<template>
  <div :class="{'nav-open': $sidebar.showSidebar}">
    <notifications></notifications>
    <router-view></router-view>
  </div>
</template>

<script>
  export default {}
</script>
<style lang="scss">
  body {
      font-family: 'Roboto' !important;
  }
  /* Global footer positioning fix */
  .main-panel {
    display: flex;
    flex-direction: column;
    min-height: 100vh !important;
    padding-bottom: 0 !important;
  }
  
  .footer {
    margin-top: auto !important;
    position: relative !important;
    z-index: 1 !important;
  }
  
  .content {
    flex: 1;
    margin-bottom: 0 !important;
    min-height: calc(100vh - 140px);
  }
  
  .card {
    margin-bottom: 0 !important;
  }
  
  .table-responsive {
    margin-bottom: 0 !important;
  }
  
  .pagination {
    margin-bottom: 0 !important;
  }

  .vue-notifyjs.notifications{
    .list-move {
      transition: transform 0.3s, opacity 0.4s;
    }
    .list-item {
      display: inline-block;
      margin-right: 10px;

    }
    .list-enter-active {
      transition: transform 0.2s ease-in, opacity 0.4s ease-in;
    }
    .list-leave-active {
      transition: transform 1s ease-out, opacity 0.4s ease-out;
    }

    .list-enter {
      opacity: 0;
      transform: scale(1.1);

    }
    .list-leave-to {
      opacity: 0;
      transform: scale(1.2, 0.7);
    }
    .btn{
        border-color: rgb(37, 91, 48) !important;
        color: rgb(37, 91, 48) !important;
    }
    .btn-outline-primary {
      border-color: rgb(37, 91, 48) !important;
      color: rgb(37, 91, 48) !important;
    }
    .btn-outline-primary:not(:disabled):not(.disabled):active{
        color: #fff;
        background-color: rgb(37, 91, 48) !important;
        border-color: rgb(37, 91, 48) !important;
    }
    .badge-primary {
      color: rgba(240, 206, 13, 0.937) !important;
      background-color: rgb(37, 91, 48) !important;
    }
    .badge{
      padding: 0.5em 1.6em !important;
    }
  }
</style>
